import script from "./TressSpecialAccessoriesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressSpecialAccessoriesModal.vue?vue&type=script&lang=ts&setup=true"

import "./TressSpecialAccessoriesModal.vue?vue&type=style&index=0&id=a889b2ce&lang=scss"

const __exports__ = script;

export default __exports__